module.exports = __webpack_public_path__ + "static/bsas014-ec8761c58fac775dbcfb888f5f746915.jpg";